// Testimonios — página /testimonios-eos
//
// Cómo agregar/completar un testimonio:
// - quotes: reemplazar los textos "[Pendiente: ...]" por las frases reales del cliente.
// - videoId: ID del video de YouTube (ej: "EYwWG_I8v0I", la parte después de youtube.com/embed/
//   o v= en la URL). Dejar en null hasta recibir el video — se muestra un placeholder "Video
//   próximamente" mientras tanto.
// - poster: ruta de una imagen de respaldo opcional para el video (ej: "/testimonios/alvaro.jpg").

export const TESTIMONIALS = [
  {
    id: "alvaro-anon",
    name: "Álvaro Añón",
    role: "Founder & CEO",
    company: "Soho.lat",
    quotes: [
      "Pasamos de conversar lo que queríamos lograr a ejecutar acciones concretas.",
      "EOS nos dio prioridades claras, una visión común y responsables concretos.",
      "Las reuniones dejaron de ser solo conversación: hoy se enfocan en datos, responsables y acciones.",
      "Recomiendo a Carlos Garcín como Implementador de EOS.",
    ],
    videoId: "79eYtP9iRr4",
    poster: null,
  },
];

